module.exports = __webpack_public_path__ + "img/2m.21265268.jpg";